import { layoutViews } from "piramis-base-components/src/plugins/AdminTemplate/includes/types/Config"
import { BaseTemplateConfig } from "piramis-base-components/src/plugins/AdminTemplate/NewConfig"
import { actionTypeBreadcrumb, baseUserBreadcrumbs } from "@/includes/AppConfigBreadcrumbsHelper";
import i18n from "@/i18n/i18n";
import store from "@/store/store";

export const routes: BaseTemplateConfig['routes'] = [
  {
    path: '',
    component: layoutViews["Panel"],
    children: [
      {
        name: 'Users',
        path: '/',
        component: () => import('../../views/users.vue'),
      },
      {
        name: 'User',
        path: '/user/:id',
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseUserBreadcrumbs(),
              { label: i18n.t('menu_user_title') }
            ]
          }
        },
        component: () => import('../../views/user-dashboard.vue'),
      },
      {
        name: 'Events',
        path: '/user/:id/events',
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseUserBreadcrumbs(),
              { label: i18n.t('menu_events_title') }
            ]
          }
        },
        component: () => import('../../views/events.vue'),
      },
      {
        name: 'Triggers',
        path: '/user/:id/triggers',
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseUserBreadcrumbs(),
              { label: i18n.t('menu_triggers_title') }
            ]
          }
        },
        component: () => import('../../views/triggers.vue'),
      },
      {
        name: 'Trigger',
        path: '/user/:id/trigger/:actionType',
        component: () => import('../../views/trigger.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            const query = ctx.route.query.triggerKey;
            const trigger = store.state.triggerState.frontendTriggers?.find(t => t.key === query)

            return [
              ...baseUserBreadcrumbs(),
              { label: i18n.t('menu_triggers_title'), routeName: 'Triggers' },
              ...trigger ? [ { label: trigger.config.name } ] : [],
              { label: actionTypeBreadcrumb(ctx) }
            ]
          }
        },
      },
      {
        name: 'Triggers_statistics',
        path: '/user/:id/statistics',
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseUserBreadcrumbs(),
              { label: i18n.t('menu_statistics_tab_title') },
              { label: i18n.t('menu_triggers_statistics_title') }
            ]
          }
        },
        component: () => import('../../views/statistics/triggers-statistics.vue'),
      },
      {
        name: 'Events_statistics',
        path: '/user/:id/events-statistics',
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseUserBreadcrumbs(),
              { label: i18n.t('menu_statistics_tab_title') },
              { label: i18n.t('menu_events_statistics_title') }
            ]
          }
        },
        component: () => import('../../views/statistics/events-statistics.vue'),
      },
      {
        name: 'Buy',
        path: '/user/:id/buy',
        component: () => import('../../views/license-buy.vue'),
      }
    ]
  }
]
